// extracted by mini-css-extract-plugin
export default {"container":"AnnouncementCard_container__ZB-pA","body":"AnnouncementCard_body__FPnjj","title":"AnnouncementCard_title__BEz4R","description":"AnnouncementCard_description__eCs6l"};